// /src/core/http.ts

export function isLocalHost(input?: string | null): boolean {
  if (!input) return false;

  try {
    // If input is a full URL, this works directly.
    // If input is host[:port], prefix a scheme so URL can parse it.
    const u = input.includes("://")
      ? new URL(input)
      : new URL(`http://${input}`);

    const host = u.hostname.toLowerCase();

    return (
      host === "localhost" ||
      host === "127.0.0.1" ||
      host.endsWith(".localhost") ||
      host.endsWith(".jungle")
    );
  } catch {
    // If parsing fails, be conservative: treat as non-localhost (less privileged).
    return false;
  }
}

export function getApiBaseV1(): string {
    const pageHost = (window.location.hostname || "").toLowerCase();
    
    // Local dev: API is your local API port
    if (isLocalHost(pageHost)) {
        // we need both localhost and 127.0.0.1 to access praxis and testcontext tenants locally
        return `http://${pageHost}:5000/v1`; // was: "http://localhost:5000/v1";
    }
    
    // Azure / real domains:
    // praxis-test.bushinconsulting.com        -> api.praxis-test.bushinconsulting.com
    // testcontext.bushinconsulting.com        -> api.testcontext.bushinconsulting.com
    // etc.
    const apiHost = `api.${pageHost}`;
    return `https://${apiHost}/v1`;
}

export function apiOrigin(): string {
  return apiOriginFromV1(getApiBaseV1());
}

export function apiOriginFromV1(apiBaseV1: string) {
  return apiBaseV1.replace(/\/v1\/?$/i, "");
}

// /src/core/http.ts
export async function postJson<TResponse>(
  url: string,
  body: unknown
): Promise<TResponse> {
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(
      `HTTP ${res.status} ${res.statusText}${txt ? ` — ${txt}` : ""}`
    );
  }

  return (await res.json()) as TResponse;
}
